import {ThreePlinth} from "../ThreePlinth";

export class ThreePlinthArc extends ThreePlinth {

}